module.exports = __webpack_public_path__ + "img/bannerBlue.181cb977.jpg";